import CustomerRecord           from "../../../../domain/record/customer/CustomerRecord";
import CustomerRecordWidget     from "../../../../domain/record/customer/widget/CustomerRecordWidget";
import CustomerRecordWidgetItem from "../../../../domain/record/customer/widget/item/CustomerRecordWidgetItem";
import ResKaReduxAction         from "../../ResKaReduxAction";
import Date                     from "../../../../domain/fundamentals/date/Date";

export enum ACTION_TYPE {
  SET_CUSTOMER_RECORD = "SET_CUSTOMER_RECORD",
  SET_CUSTOMER_RECORD_DATE = "SET_CUSTOMER_RECORD_DATE",
  SET_CUSTOMER_RECORD_WIDGET_VALUE = "SET_CUSTOMER_RECORD_WIDGET_VALUE",
  SET_CUSTOMER_RECORD_WIDGET_ITEM_VALUE = "SET_CUSTOMER_RECORD_WIDGET_ITEM_VALUE",
}

export interface SetCustomerRecordAction extends ResKaReduxAction {
  customerRecord: CustomerRecord;
}

export interface SetCustomerRecordDateAction extends ResKaReduxAction{
  date: Date;
}

export interface SetCustomerRecordWidgetAction extends ResKaReduxAction {
  widgetIndex: number;
  widget: CustomerRecordWidget;
}

export interface SetCustomerRecordWidgetItemAction extends ResKaReduxAction {
  widgetIndex: number;
  widgetItemIndex: number;
  widgetItem: CustomerRecordWidgetItem;
}

export type CustomerRecordAction =
  SetCustomerRecordAction
  | SetCustomerRecordDateAction
  | SetCustomerRecordWidgetAction
  | SetCustomerRecordWidgetItemAction;

export const setCustomerRecordAction = (customerRecord: CustomerRecord): SetCustomerRecordAction => ({
  type: ACTION_TYPE.SET_CUSTOMER_RECORD,
  customerRecord: customerRecord,
});

export const setCustomerRecordDateAction = (date: Date): SetCustomerRecordDateAction => ({
  type: ACTION_TYPE.SET_CUSTOMER_RECORD_DATE,
  date: date,
});

export const setCustomerRecordWidgetAction = (widgetIndex: number, widget: CustomerRecordWidget): SetCustomerRecordWidgetAction => ({
  type: ACTION_TYPE.SET_CUSTOMER_RECORD_WIDGET_VALUE,
  widgetIndex: widgetIndex,
  widget: widget,
});

export const setCustomerRecordWidgetItemAction = (widgetIndex: number, widgetItemIndex: number, widgetItem: CustomerRecordWidgetItem): SetCustomerRecordWidgetItemAction => ({
  type: ACTION_TYPE.SET_CUSTOMER_RECORD_WIDGET_ITEM_VALUE,
  widgetIndex: widgetIndex,
  widgetItemIndex: widgetItemIndex,
  widgetItem: widgetItem,
});
